// extracted by mini-css-extract-plugin
module.exports = {"item":"CounterpartyCommentsView_item_36oc2"};